module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/src/assets/fonts/font-awesome-4.7.0/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = ../../../../../src/assets/fonts/font-awesome-4.7.0/fonts/fontawesome-webfont.eot?v=4.7.0
// module chunks = 7